//FacilityData
export const FACILITY_DICTIONARY = [
  {
    options: "facilities",
    save: { store: false, self: true },
    load: "self",
    keyName: "facility_name",
    valueName: "facility_name",
  },
  {
    options: "companies",
    save: { store: false, self: true },
    load: "self",
    keyName: "dept_name",
    valueName: "dept_name",
  },
  {
    options: "facility_types",
    save: { store: false, self: true },
    load: "self",
    keyName: "facility_type_name",
    valueName: "facility_type_name",
  },
];
export const FACILITY_COLUMNS = [
  {
    header: "Ид",
    field: "facility_id",
    sortable: true,
    bodyStyle: "text-align: right;",
    filterData: {
      type: "InputText",
      "max-width": "60px",
      placeholder: "...",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Компания",
    field: "dept_name",
    sortable: true,
    filterData: {
      options: "companies",
      type: "MultiSelect",
      mode: "in",
      placeholder: "Выберите компанию",
      attrList: { type: "number", step: "1" },
      "max-width": "250px",
    },
  },
  {
    header: "Тип объекта",
    field: "facility_type_name",
    sortable: true,
    filterData: {
      options: "facility_types",
      type: "MultiSelect",
      mode: "in",
      placeholder: "Выберите тип объекта",
    },
  },
  {
    header: "Объект",
    field: "facility_name",
    sortable: true,
    filterData: {
      options: "facilities",
      type: "MultiSelect",
      mode: "in",
      attrList: { filter: true },
      valueName: "facility_name",
      placeholder: "Выберите объект",
    },
  },
  {
    header: "Кол-во фланцев",
    field: "flange_count",
    sortable: true,
    bodyStyle: "text-align: right;",
    filterData: {
      type: "InputText",
      "max-width": "60px",
      placeholder: "...",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Кол-во фланцев всего",
    field: "flange_count_all",
    sortable: true,
    bodyStyle: "text-align: right;",
    filterData: {
      type: "InputText",
      "max-width": "60px",
      placeholder: "...",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Период обработ. сек",
    field: "facility_process_rate",
    bodyStyle: "text-align: right;",
    sortable: true,
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "90px",
      attrList: { mode: "decimal", step: 1, },
    },
  },
  {
    header: "Позиция",
    field: "facility_position",
    bodyStyle: "text-align: right;",
    sortable: true,
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "90px",
      attrList: { mode: "decimal", step: 1, },
    },
    summary: {
      header: "max",
      type: "max",
    },
  },
  {
    header: "Устройство",
    field: "device_name",
    sortable: true,
  },
  {
    header: "Акутал.",
    field: "facility_actual",
    dataType: "component",
    bodyStyle: "text-align: center;",
    sortable: true,
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
  },
  {
    header: "Состояние",
    field: "facility_mode_id",
    bodyStyle: "text-align: center;",
    sortable: true,
    dataType: "dropdown",
    configComponent: {
      attrList: {
        options: [{ id: 1, name: 'Актуал' }, { id: 2, name: 'Тест (не сохр)' }, { id: 3, name: 'Не актуал' }],
        optionLabel: 'name',
        optionValue: 'id'
      },
    },
  }
];
//FacilityDevice
export const FACILITY_DEVICE_DICTIONARY = [
  {
    options: "source",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "source",
    entitySpec: "data",
  },
];
export const FACILITY_DEVICE_COLUMNS = [
  {
    header: "Источник",
    field: "source_id",
    loadOptions: "source",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "source_name",
        optionValue: "source_id",
        appendTo: "body",
      },
    },
  },
  {
    header: "Наименование устройства",
    field: "device_name",
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Актуальность",
    field: "device_actual",
    bodyStyle: "text-align: center;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: { name: "Checkbox", attrList: { binary: true } },
  },
  {
    header: "Тип",
    field: "source_id",
    loadOptions: "source",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "source_params",
        optionValue: "source_id",
        appendTo: "body",
        disabled: true,
      },
    },
  },
];
//FacilityDiagram
export const FACILITY_DIAGRAM_DICTIONARY = [{
  options: "facility",
  save: { store: false, self: true },
  load: "db",
  serviceName: "BaseService",
  entityName: "facility",
  entitySpec: "ref",
}];
export const FACILITY_DIAGRAM_COLUMNS = [
  {
    header: "Фл.(Ус)",
    field: "parent_flange_no",
    bodyStyle: "text-align: right; max-width: 100px",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Тип",
    field: "child_facility_id",
    loadOptions: "facility",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "facility_type_name",
        optionValue: "facility_id",
        appendTo: "body",
        disabled: true,
      },
    },
  },
  {
    header: "Скважины, НПО",
    field: "child_facility_id",
    loadOptions: "facility",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "facility_name",
        optionValue: "facility_id",
        filter: true,
        appendTo: "body",
      },
    },
  },
  {
    header: "Фланец скважины",
    field: "child_flange_no",
    bodyStyle: "text-align: right; max-width: 120px",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Топроса, сек",
    field: "flange_refresh_rate",
    bodyStyle: "text-align: right; max-width: 100px",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Тобработ, сек",
    field: "flange_process_rate",
    bodyStyle: "text-align: right; max-width: 100px",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Дата подключения",
    field: "date_begin",
    dataType: "date-time",
    conversion: true,
    gmt: true,
    editor: {
      name: "Calendar",
      attrList: {
        showIcon: true,
        showTime: true,
        dateFormat: "dd.mm.yy",
        appendTo: "body",
        showButtonBar: true,
        hideOnDateTimeSelect: true,
      },
    },
  },
  {
    header: "Дата отключения",
    field: "date_end",
    dataType: "date-time",
    conversion: true,
    gmt: true,
    editor: {
      name: "Calendar",
      attrList: {
        showIcon: true,
        showTime: true,
        dateFormat: "dd.mm.yy",
        appendTo: "body",
        showButtonBar: true,
        hideOnDateTimeSelect: true,
      },
    },
  },
];
//FacilityDialog
export const FACILITY_DIALOG_DICTIONARY = [
  { options: "dept", save: { store: false, self: true }, load: "store" },
  {
    options: "script",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "script",
  },
  {
    options: "facilityType",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "facility_type",
  },
  {
    options: "cluster",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "cluster",
  },
  {
    options: "facilityMode",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "facility_mode",
  },
  {
    options: "propertyAtribute",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "property_attribute",
  },
];
export const FACILITY_DIALOG_REQUIRED_FILEDS = {
  facility_name: true,
  facility_type_id: true,
  script_id: false,
  dept_id: true,
  cluster_id: false,
  flange_count: false,
  facility_process_rate: true,
  facility_position: false,
  facility_mode_id: true,
};
//FacilityFlange
export const FACILITY_FLANGE_COLUMNS = [
  {
    header: "№ фланца(уса)",
    field: "flange_no",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Скважина",
    field: "hanger_names",
  },
  {
    header: "Коэф. замера",
    field: "meter_factor",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "0.1" },
    },
  },
  {
    header: "Длительность замера, мин",
    field: "switch_flange_time",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Длительность замера, ч",
    field: "switch_flange_time_hour",
    bodyStyle: "text-align: right;",
  },
  {
    header: "Актуальность",
    field: "flange_actual",
    bodyStyle: "text-align: center;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: { name: "Checkbox", attrList: { binary: true } },
  },
];
//FacilityProperty
export const FACILITY_PROPERTY_DICTIONARY = [
  /*{
    options: "script",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "script",
  },*/
  {
    options: "propertyType",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "property_type",
    entitySpec: "data",
  },
  {
    options: "unit",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "unit",
  },
];
export const FACILITY_PROPERTY_COLUMNS = [
  {
    header: "PID",
    field: "property_id",
    sortable: true,
    bodyStyle: "width:60px; text-align: right;",
    filterData: {
      type: "InputText",
      "max-width": "50px",
      attrList: { type: "number", step: "1" },
      placeholder: "...",
    },
    editor: {
      name: "InputText",
      style: (value) => {
        if (value < 0) return { color: "white" };
        return null;
      },
      attrList: {
        disabled: true,
      },
    },
  },
  {
    header: "Фл",
    field: "active_flange_no",
    sortable: true,
    bodyStyle: "width:60px; text-align: right;",
    filterData: {
      type: "InputText",
      attrList: { type: "number", step: "1" },
    },
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Тип свойств",
    field: "property_type_id",
    loadOptions: "propertyType",
    dataType: "dropdown",
    bodyStyle: "max-width:180px; overflow: hidden;",
    sortable: true,
    editor: {
      name: "Dropdown",
      attrList: {
        "v-model": "property_type_id",
        options: [],
        optionLabel: "property_type_name",
        optionValue: "property_type_id",
        appendTo: "body",
        filter: true,
      },
    },
    filterData: {
      options: "propertyType",
      "max-width": "155px",
      type: "Dropdown",
      mode: "equals",
      attrList: {
        filter: true,
        optionLabel: "property_type_name",
        optionValue: "property_type_id",
      },
    },
  },
  {
    header: "Сист. имя",
    field: "property_type_id",
    sortable: true,
    visible: false,
    dataType: "dropdown",
    loadOptions: "propertyType",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "property_type_sysname",
        optionValue: "property_type_id",
        appendTo: "body",
        disabled: true,
      },
    },
  },
  {
    header: "Устройство",
    field: "device_id",
    loadOptions: "device",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "device_name",
        optionValue: "device_id",
        appendTo: "body",
      },
    },
  },
  {
    header: "Описание",
    field: "property_desc",
    bodyStyle: "max-width:90px; overflow: hidden;",
    editor: { name: "InputText" },
  },
  {
    header: "Path",
    field: "property_path",
    sortable: true,
    bodyStyle: "max-width:160px; overflow: hidden;",
    editor: { name: "InputText" },
  },
  {
    header: "Список Path",
    field: "property_path",
    sortable: true,
    dataType: "dropdown",
    loadOptions: "source",
    bodyStyle: "max-width:160px; overflow: hidden;",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "source",
        optionValue: "property_path",
        appendTo: "body",
        filter: true,
      },
    },
  },
  {
    header: "Ед из(вх)",
    field: "unit_id",
    loadOptions: "unit",
    dataType: "dropdown",
    bodyStyle: "width:70px;",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "unit_sname",
        optionValue: "unit_id",
        appendTo: "body",
      },
    },
  },
  {
    header: "Формула",
    field: "property_formula",
    bodyStyle: "max-width:230px; overflow: hidden;",
    editor: { name: "Textarea" },
    dataType: "text",
  },
  {
    header: "Источник",
    field: "source_name",
    visible: false,
  },
  {
    header: "Коэф.",
    field: "property_factor",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "0.01" },
      style: { width: "50px" },
    },
  },
  {
    header: "Топр, сек",
    field: "property_refresh_rate",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1", min: "0" },
      style: { width: "50px" },
    },
  },
  {
    header: "Тобр, сек",
    field: "property_process_rate",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1", min: "0" },
      style: { width: "50px" },
    },
  },
  {
    header: "Тсохр, сек",
    field: "property_save_rate",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "1", min: "0" },
      style: { width: "50px" },
    },
  },
  {
    header: "Непрер.",
    field: "property_is_fast",
    bodyStyle: "text-align: center; width:80px;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    // editor: { name: "Checkbox", attrList: { binary: true } },
  },
  {
    header: "Отобр.",
    field: "property_is_visible_form",
    bodyStyle: "text-align: center; width:80px;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: { name: "Checkbox", attrList: { binary: true } },
  },
  {
    header: "Исп дату",
    field: "property_use_source_date",
    bodyStyle: "text-align: center; width:80px;",
    visible: false,
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: { name: "Checkbox", attrList: { binary: true } },
  },
];
export const FACILITY_PROPERTY_REQUIRED_FILEDS = {
  active_flange_no: true,
  property_type_id: true,
  device_id: true,
  property_path: true,
  unit_id: false,
  property_factor: true,
  property_refresh_rate: true,
  property_process_rate: true,
  property_save_rate: true
};

//FacilityPropertyWithDlg
export const FACILITY_PROPERTY_DLG_COLUMNS = [
  {
    header: "PID",
    field: "property_id",
    sortable: true,
    bodyStyle: "width:60px; text-align: right;",
    filterData: {
      type: "InputText",
      "max-width": "50px",
      attrList: { type: "number", step: "1" },
      placeholder: "...",
    },
  },
  {
    header: "Фл",
    field: "active_flange_no",
    sortable: true,
    bodyStyle: "width:60px; text-align: right;",
    filterData: {
      type: "InputText",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Тип свойств",
    field: "property_type_id",
    dataType: "dropdown",
    bodyStyle: "max-width:180px; overflow: hidden;",
    sortable: true,
    configComponent: {
      options: "propertyType",
      value: "property_type_id",
      label: "property_type_name",
    },
    filterData: {
      options: "propertyType",
      "max-width": "155px",
      type: "Dropdown",
      mode: "equals",
      attrList: {
        filter: true,
        optionLabel: "property_type_name",
        optionValue: "property_type_id",
      },
    },
  },
  {
    header: "Сист. имя",
    field: "property_type_id",
    sortable: true,
    visible: false,
    dataType: "dropdown",
    configComponent: {
      options: "propertyType",
      value: "property_type_id",
      label: "property_type_sysname",
    },
  },
  {
    header: "Устройство",
    field: "device_id",
    dataType: "dropdown",
    configComponent: {
      options: "device",
      value: "device_id",
      label: "device_name",
    },
  },
  {
    header: "Описание",
    field: "property_desc",
    bodyStyle: "max-width:90px; overflow: hidden;",
  },
  {
    header: "Path",
    field: "property_path",
    sortable: true,
    bodyStyle: "max-width:160px; overflow: hidden;",
  },
  {
    header: "Ед из(вх)",
    field: "unit_id",
    bodyStyle: "width:70px;",
    dataType: "dropdown",
    configComponent: {
      options: "unit",
      value: "unit_id",
      label: "unit_sname",
    },
  },
  {
    header: "Формула",
    field: "property_formula",
    bodyStyle: "max-width:230px; overflow: hidden; text-align: center;",
    dataType: "check-with-tooltip",
  },
  {
    header: "Источник",
    field: "source_name",
  },
  {
    header: "Коэф.",
    field: "property_factor",
    bodyStyle: "text-align: right;",
  },
  {
    header: "Топр, сек",
    field: "property_refresh_rate",
    bodyStyle: "text-align: right;",

  },
  {
    header: "Тобр, сек",
    field: "property_process_rate",
    bodyStyle: "text-align: right;",
  },
  {
    header: "Тсохр, сек",
    field: "property_save_rate",
    bodyStyle: "text-align: right;",
  },
  {
    header: "Непрер.",
    field: "property_is_fast",
    bodyStyle: "text-align: center; width:80px;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
  },
  {
    header: "Отобр.",
    field: "property_is_visible_form",
    bodyStyle: "text-align: center; width:80px;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
  },
  {
    header: "Исп дату",
    field: "property_use_source_date",
    bodyStyle: "text-align: center; width:80px;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
  },
];
//PropertyData
export const PROPERTY_DATA_DICTIONARY = [
  {
    options: "propertyAttribute",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "property_attribute",
  },
];
export const PROPERTY_DATA_COLUMNS = [
  {
    header: "Атрибут",
    loadOptions: "propertyAttribute",
    field: "property_attribute_id",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "property_attribute_name",
        optionValue: "property_attribute_id",
        appendTo: "body",
        filter: true,
      },
    },
  },
  {
    header: "Знач. источника",
    field: "property_data_value",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "0.1" },
    },
  },
  {
    header: "Расч. значение",
    field: "property_real_value",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputText",
      attrList: { type: "number", step: "0.1" },
    },
  },
  {
    header: "Текстовое значение",
    field: "property_text_desc",
    editor: {
      name: "InputText",
    },
  },
];